export default () => ({
    ocular: {
        get: () =>
            // assumption that any questions which make it this far should be visible
            true,
    },
});
